// API Configuration and Facade
const API_BASE_URL = process.env.REACT_APP_API_URL

// Default headers
const getDefaultHeaders = () => ({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
});

// Add authentication token if available
const getPublicHeaders = () => {
    const token = sessionStorage.getItem('dealerToken');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Request interceptor
const interceptRequest = async (url, options) => {
    const headers = {
        ...getDefaultHeaders(),
        ...options.headers,
    };

    return {
        ...options,
        headers,
    };
};

// Response interceptor
const interceptResponse = async (response) => {
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return response.json();
    }

    return response.text();
};

// Main fetch wrapper
const apiFetch = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;
    const interceptedOptions = await interceptRequest(url, options);

    try {
        const response = await fetch(url, interceptedOptions);
        return await interceptResponse(response);
    } catch (error) {
        console.error('API Error:', error);

        throw error;
        
    }
};

export const apiPublic = {
    fetch: (endpoint, options = {}) => {
        const headers = {
            ...options.headers,
        };
        const token = sessionStorage.getItem('token');
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        return apiFetch(endpoint, {
            ...options,
            headers,
            body: options.body ? JSON.stringify(options.body) : undefined,
        });
    },
};

export const apiAuth = {
    fetch: (endpoint, options = {}) => {
        const headers = {
            ...options.headers,
        };
        const token = sessionStorage.getItem('dealerToken');
        if (token) {    
            headers['Authorization'] = `Bearer ${token}`;
        }

        return apiFetch(endpoint, {
            ...options,
            headers,
            body: options.body ? JSON.stringify(options.body) : undefined,
        });
    },
};

